import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./globalLayout.css";
import {
    useGetEmergencyStopDataList,
    useGetGeneralOnoingPlanListMutation,
    useGetMyPanels,
    useGetOnoingPlanListForTodayMutation,
    useGetSystemProcedures,
    useTokenCheckWithRefreshToken,
} from "../hooks/useGetDataQuery";
import { BlockUI } from "primereact/blockui";
import { useTranslation } from "react-i18next";
import { locale } from "primereact/api";
import GlobalLayoutMenubar from "./globalLayoutMenubar";
import { useTokenCheck } from "../hooks/useTokenCheck";
import { useGetAllPrimaryData } from "../hooks/useGetAllPrimaryData";
import AboutUs from "../Support/aboutUs";

const GlobalLayout = () => {
    const {
        mutate: getSystemProceduresMutation,
        data: systemProcedures,
        isSuccess: isSuccessSystemProcedures
    } = useGetSystemProcedures();

    const {
        mutate: getMyPanelsMutation,
        data: panelList,
        isSuccess: isSuccessMyPanelList,
    } = useGetMyPanels();

    const {
        mutate: getGeneralOngoingPlanListMutation,
        data: generalOngoingPlanListData,
        isSuccess: isSuccessGeneralOngoingPlanList,
        isError: isErrorGeneralOngoingPlanList
    } = useGetGeneralOnoingPlanListMutation();

    const {
        mutate: getOngoingPlanListForTodayMutation,
        data: ongoingPlanListForTodayData,
        isSuccess: isSuccessOngoingPlanListForToday,
        isError: isErrorOngoingPlanListForToday
    } = useGetOnoingPlanListForTodayMutation();

    const {
        mutate: getEmergencyStopDataListMutation,
        data: emergencyStopDataListData,
        isSuccess: isSuccessEmergencyStopDataList,
        isError: isErrorEmergencyStopDataList
    } = useGetEmergencyStopDataList();

    const navigate = useNavigate();

    const { t, i18n } = useTranslation();
    const [lang, setLang] = useState<any>()

    const [blockUI, setBlockUI] = useState(true);
    const [blockOngoingPlanListData, setBlockOngoingPlanListData] = useState(true);
    const [blockOngoingPlanListDataForToday, setBlockOngoingPlanListDataForToday] = useState(true);

    const [pathname, setPathName] = useState<any>();
    const [doctorName, setDoctorName] = useState<any>("");

    const [patientList, setPatientList] = useState<any>([]);
    const [patientNewList, setPatientNewList] = useState<any>([]);


    const [myPanels, setMyPanel] = useState<any>([]);
    const [systemPanels, setSystemPanels] = useState<any>([]);

    const [ongoingPlanListData, setOngoingPlanListData] = useState<any>([]);
    const [allOngoingPlanListData, setAllOngoingPlanListData] = useState<any>([]);

    const [emergencyStopDataList, setEmergencyStopDataList] = useState<any>([]);

    const [aboutUsdialogVisible, setAboutUsdialogVisible] = useState<any>(false);

    const { isSuccess: isSuccessTokenCheck, isError: isErrorTokenCheck } = useTokenCheckWithRefreshToken();


    const capitalizeFirstLetter = (string: string) => {
        if (!string) return '';
        let words = string.toLowerCase().split(' ');
        words = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
        return words.join(' ');
    };

    useEffect(() => {
        /* eslint-disable no-restricted-globals */
        setPathName(location.pathname.substring(location.pathname.lastIndexOf("/"), location?.pathname.length));

        localStorage.getItem("i18nextLng") === "en" ? setLang({ name: 'EN', code: 'GB', lang: "en" })
            : setLang({ name: 'TR', code: 'TR', lang: 'tr' })

        const firstName = JSON.parse(localStorage.getItem("account") as any)?.firstName;
        const lastName = JSON.parse(localStorage.getItem("account") as any)?.lastName;
        if (lastName) {
            setDoctorName("Dr. " + capitalizeFirstLetter(lastName));
        }
        else if (firstName) {
            setDoctorName("Dr. " + capitalizeFirstLetter(firstName));
        }
    }, []);

    useEffect(() => {
        if (pathname) {
            if (pathname === "/mobithera") {
                navigate({ pathname: "/mobithera/home" });
            } else {
                navigate({ pathname: "/mobithera" + pathname });
            }
        }
    }, [pathname]);

    useEffect(() => {
        if (lang) {
            i18n.changeLanguage(lang.lang)
            locale(lang.lang);
        }
    }, [lang]);

    useTokenCheck(
        {
            isSuccessTokenCheck,
            isErrorTokenCheck,

            navigate,

            getMyPanelsMutation,
            getSystemProceduresMutation,
            getOngoingPlanListForTodayMutation,
            getGeneralOngoingPlanListMutation,
            getEmergencyStopDataListMutation,

            setBlockUI,

            i18n
        })

    useGetAllPrimaryData(
        {
            isSuccessSystemProcedures,
            isSuccessMyPanelList,
            isSuccessOngoingPlanListForToday,
            isErrorOngoingPlanListForToday,
            isSuccessGeneralOngoingPlanList,
            isErrorGeneralOngoingPlanList,
            isSuccessEmergencyStopDataList,
            isErrorEmergencyStopDataList,

            systemProcedures,
            panelList,
            ongoingPlanListForTodayData,
            generalOngoingPlanListData,
            emergencyStopDataListData,

            setSystemPanels,
            setMyPanel,

            setOngoingPlanListData,
            setAllOngoingPlanListData,

            setBlockOngoingPlanListData,
            setBlockOngoingPlanListDataForToday,

            setEmergencyStopDataList,
        })

    return (
        <div >
            <BlockUI
                blocked={blockUI}
                fullScreen
                style={{ backgroundColor: "transparent" }}
                template={
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <dotlottie-player
                            src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                            background="transparent"
                            speed="1"
                            style={{ width: "3rem", height: "3rem" }}
                            loop
                            autoplay
                        />
                    </div>
                }
            >
                <div className="flex flex-column" style={{ minHeight: "100vh" }}>

                    <GlobalLayoutMenubar
                        navigate={navigate}
                        setPatientList={setPatientNewList}
                        doctorName={doctorName}
                        lang={lang}
                        setLang={setLang}
                        t={t}
                        emergencyStopDataList={emergencyStopDataList}
                        setEmergencyStopDataList={setEmergencyStopDataList}
                    />

                    <div className="w-full absolute h-6rem" style={{ backgroundColor: "#2D3967", top: "5rem" }}></div>

                    <div
                        className="h-full w-full flex flex-column m-0 flex-nowrap relative py-4 step2"
                        style={{
                            flex: 1,
                            paddingLeft: "4rem",
                            paddingRight: "4rem",
                            top: "7rem",
                            zIndex: 999
                        }}
                    >
                        <Outlet
                            context={{
                                t,
                                i18n,

                                patientNewList,
                                setPatientNewList,
                                patientList,
                                setPatientList,

                                ongoingPlanListData,
                                allOngoingPlanListData,
                                blockOngoingPlanListData,
                                blockOngoingPlanListDataForToday,

                                systemPanels,
                                myPanels,
                                setMyPanel,
                            }}
                        />
                    </div>

                    <div className="w-full flex justify-content-center align-items-center gap-4"
                        style={{
                            marginTop: "7rem",
                            height: "3rem",
                            backgroundColor: "#FFFFFF",
                            position: "relative",

                        }}
                    >
                        <p className="text-sm" style={{ color: "#9EA4B9" }}>© {new Date().getFullYear()} <span className="font-bold" style={{ color: "#2D3967" }}>{t("mobitheraTechnology")}.</span> {t("allRightsReserved")}.</p>
                        <div className="flex justify-content-center align-items-center gap-2">

                            <a href="/mobithera/faq" style={{ color: "#2D3967" }}>{t("faq")}</a>

                            <div style={{
                                height: "1.5rem",
                                border: "1px solid #9EA4B9"
                            }}></div>

                            <a onClick={() => setAboutUsdialogVisible(true)} style={{ color: "#2D3967", cursor: "pointer" ,textDecoration: "underline"}}>{t("aboutUs")} </a>
                            <AboutUs t={t} aboutUsdialogVisible={aboutUsdialogVisible} setAboutUsdialogVisible={setAboutUsdialogVisible} isLoggedIn />

                            <div style={{
                                height: "1.5rem",
                                border: "1px solid #9EA4B9"
                            }}></div>

                            <a href="https://mobithera.com/trust-center" target="_blank" rel="noopener noreferrer" style={{ color: "#2D3967" }}>{t("trustCenter")}</a>
                            
                            <div style={{
                                height: "1.5rem",
                                border: "1px solid #9EA4B9"
                            }}></div>

                            <a style={{ color: "#2D3967" }}>Ver. 4.2.0</a>

                        </div>
                    </div>
                </div>
            </BlockUI>
        </div>
    );
};

export default GlobalLayout;
